import React from 'react';
import {MvtTest} from '../MvtTest/MvtTest';

export function hasAbacusTest(abacus, key) {
    return abacus &&
        typeof abacus[key] !== 'undefined' &&
        abacus[key].value !== -1;
}

export function wrapInTest(abacus, label, element) {
    return hasAbacusTest(abacus, label) ? (
        <MvtTest test={label} report>
            {element}
        </MvtTest>
    ) : element;
}
